@if (changelog(); as state) {
  @if (isError(state)) {
    <p-message
      severity="error"
      text="Der Changelog konnte nicht geladen werden."></p-message>
  } @else {
    <article class="changelog" [innerHTML]="state.html"></article>
  }
} @else {
  <div class="flex flex-column gap-3">
    <p-skeleton width="40%" height="2rem"></p-skeleton>
    <p-skeleton height="8rem"></p-skeleton>
    <p-skeleton height="12rem"></p-skeleton>
  </div>
}
